import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardCheckChip } from "../../../../../../shared/components/filters/StandardCheckChip"

import { DetailedProductGroups } from "../../priceListTypes"
import { countPricedProducts } from "./adjustPricesLib"
import { useScopeSelection } from "./useScopeSelection"

const useStyles = makeStyles()(() => ({
    chips: {
        flexWrap: "wrap",
        gap: ".5rem",
    },
}))

type ScopeFieldsProps = Readonly<{
    productGroups: ReadonlyArray<DetailedProductGroups>
}>

export function ScopeFields({ productGroups }: ScopeFieldsProps) {
    const { classes } = useStyles()
    const { selected, toggle } = useScopeSelection(productGroups)

    return (
        <Stack direction="row" className={classes.chips}>
            {productGroups.map((group) => (
                <StandardCheckChip
                    key={group.id}
                    isChecked={selected.has(group.id)}
                    count={countPricedProducts(group)}
                    onChange={() => toggle(group.id)}
                >
                    {group.name}
                </StandardCheckChip>
            ))}
        </Stack>
    )
}
